import { useContext, useEffect } from "react";
import { NotificationContext } from "./notification.provider";
import { useAuth } from "./authentication.provider";
import { io } from "socket.io-client";
import { useWalletStore } from "./userWallet.store";
import { IoIosWallet } from "react-icons/io";

export const BalanceNotifierProvider = () => {
    const { dispatch } = useContext(NotificationContext)!;
    const { accessToken, customerInfo } = useAuth()!;
    const userId = customerInfo?.user?.id;

    useEffect(() => {
        if (!accessToken || !userId) return;

        const socket = io(process.env.REACT_APP_RHOMBU_BACKEND_URL, {
            path: "/ws",
            withCredentials: true,
            auth: { token: accessToken },
        });

        // socket.on("connect", () => {});

        socket.on("walletUpdated", (data: { balance: number; by?: string }) => {
            useWalletStore.getState().setBalance(data.balance);
        });

        socket.on("walletDeducted", (data: { balance: number; by: string; to: string }) => {
            useWalletStore.getState().setBalance(data.balance);

            dispatch({
                type: "ADD_NOTIFICATION",
                payload: {
                    title: "Wallet Debited",
                    message: `₦${data.by} was deducted for payment to ${data.to}. New balance: ₦${data.balance.toLocaleString()}`,
                    status: "info",
                    icon: <IoIosWallet />,
                },
            });
        });

        return () => {
            socket.disconnect();
        };
    }, [accessToken, userId]);

    return null;
};
